import { isEmbeddedDocument } from '@trello/browser';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import { headerBranding, HeaderOptions } from './header-branding';
import { importWithRetry } from '@trello/use-lazy-component';
import { currentModelManager } from 'app/scripts/controller/currentModelManager';

export const Header = {
  renderBannerContent: function (...args: unknown[]) {
    return importWithRetry(
      () =>
        import(
          /* webpackChunkName: "banner-content" */ './renderBannerContent'
        ),
    ).then(({ renderBannerContent }) => {
      renderBannerContent.call(this, ...args);
    });
  },
  headerBranding,
  embeddedDocumentCheck: function () {
    if (isEmbeddedDocument()) {
      if (currentModelManager.onAnyBoardView()) {
        // We won't show the header if the board is embedded.
        $('[data-js-id="header-container"]').hide();
      } else {
        // We only need the logo if Trello is embedded.
        $('[data-js-id="header-container"]').show();
      }
    } else {
      // show the header otherwise
      $('[data-js-id="header-container"]').show();
    }
  },
  showHeader: function (opts: HeaderOptions = {}) {
    this.embeddedDocumentCheck();
    this.headerBranding(opts);
    this.renderBannerContent();
  },
};
